import { Component, OnInit, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var bootstrap: any;

@Component({
  selector: 'app-descontos',
  templateUrl: './descontos.component.html',
  standalone: false

})
export class DescontosComponent implements OnInit {

  visibleSection: string | null = null;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const sections = document.querySelectorAll('.discount');
    const viewportCenter = window.innerHeight / 3;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= viewportCenter && rect.bottom >= viewportCenter) {
        this.visibleSection = section.id;
        this.activeTab = +this.visibleSection;
      }
    });
  }

  // ---CMS---
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  discounts_content: string = 'linhas-desconto';
  discountsInfo: any = {};

  activeTab: number = 0;

  constructor(
    private cmsService: CmsService,
    private route: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private title: Title
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['descontos']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.discounts_content, this.language).subscribe(
      {
        next: data => {
          this.discountsInfo = data['body']['data'];
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }

  scrollToTab(index: number): void {
    this.activeTab = index;
    const element = document.getElementById(index.toString());
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
